export default __webpack_public_path__ + "static/media/iphone2.1c3bb33a.png";